module.exports = __webpack_public_path__ + "img/caizilin.08884ed8.jpeg";